import { useEffect } from 'react';
import { connect, useDispatch } from "react-redux";
import {
  setTreeVideosIframe,
  setVideoIframe,
  setModeIframe
} from "./redux/actions/index";

// Iframe Module
function ConnectedMainWrapper({ message }) {
  const dispatch = useDispatch();

  // Message from parent - Array Tree
  useEffect(() => {
    if (message) {
      if (message.length === 1) {
        const [block] = message;
        if (block.action && block.mode && block.action === 'switch') {
          dispatch(setModeIframe(block.mode));
        }
      } else {
        const lessons = message.map( x => x.lessons.map( y => { y.courseId = x.contentId; /*y.lock = true;*/ return y; } ) ).flat();
        dispatch(setTreeVideosIframe(lessons));
        const activeLesson = lessons.find( x => x.currentLessonActive );
        dispatch(setVideoIframe(activeLesson));
      }
    } else {
      window.parent.postMessage([{ "action": "getPostData" }], "*");
    }
  }, [message, dispatch])

  return null;
}

const MainWrapper = connect(
  state => ({
    message: state.IMessage
  })
)(ConnectedMainWrapper);

export default MainWrapper;
